import React, { useState } from "react";
import "./component.css";
import Sidebar from "../../Navigation/Sidebar/Sidebar";
import leftArrow from "../../../assests/leftArrow.svg";
import { useNavigate, useParams } from "react-router-dom";
import Table from "react-bootstrap/Table";
import LoadingSpinner from "../../Loading/component";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import moment from "moment-timezone";
import awaitingIcon from "../../../assests/awaitingIcon.svg";
import search from "../../../assests/search.svg";
import combodetailsIcon from "../../../assests/combodetailsIcon.svg";
import emotions7 from "../../../assests/emotions7.svg";
import remove from "../../../assests/remove.svg";

export const ComboDetailsComponent = (props) => {
  const { comboId } = useParams();
  const [machineSearchQuery, setMachineSearchQuery] = useState("");
  const [showVMModal, setShowVMModal] = useState(false);
  const [selectedVMIDs, setSelectedVMIDs] = useState([]);
  const isMobile = window.innerWidth <= 576;

  const handleSeeMore = (vmIDs) => {
    setSelectedVMIDs(vmIDs);
    setShowVMModal(true);
  };

  const handleCloseModal = () => {
    setShowVMModal(false);
    setSelectedVMIDs([]);
  };
  
  const navigate = useNavigate();

  const arrowClick = (event) => {
    event.preventDefault();
    navigate(-1);
  };

  const handleSearchChange = (e) => {
    setMachineSearchQuery(e.target.value);
  };

  const filteredCohorts = props.comboDetailsData?.combo_cohorts?.filter(
    (machine) => {
      const cohortIdString = String(machine?.cohort_id || "");
      const searchQueryString = String(machineSearchQuery || "");

      return searchQueryString
        ? cohortIdString.includes(searchQueryString)
        : true;
    }
  );

  const handleAddCohortCombo = () => {
    navigate(`/home/comboupdatecohort/${comboId}`);
  };
  
  const handleUpdateComboDetails = () => {
    navigate(`/home/comboupdatedetails/${comboId}`);
  };

  return (
    <div className="combo-details-wrapper">
      <Sidebar />
      
      {props.loading ? (
        <LoadingSpinner />
      ) : (
        <div className="combo-details-content">
          <div className="combo-header-section">
            <button onClick={arrowClick} className="back-button">
              <img src={leftArrow} alt="Back" />
            </button>
            <h1>Combo ID {props.comboDetailsData?.id}</h1>
          </div>

          {/* Combo Details Section */}
          <div className="combo-details-section">
            <div className="section-header">
              <div className="section-title">
                <img src={combodetailsIcon} alt="Combo" />
                <h2>Combo Details</h2>
              </div>
              <button 
                className="edit-button"
                onClick={() => handleUpdateComboDetails(comboId)}
              >
                Edit
              </button>
            </div>

            <div className="combo-info-container">
              <div className="combo-basic-info">
                <h3>{props.comboDetailsData?.name}</h3>
                <p className="combo-description">
                  <strong>Description:</strong> {props.comboDetailsData?.description}
                </p>
              </div>

              <div className="combo-details-grid">
                <div className="combo-image-container">
                  <div className="combo-image-wrapper">
                    <img
                      src={`https://s3.ap-south-1.amazonaws.com/daalchini/dcprod/${props.comboDetailsData?.image_url}`}
                      alt="Combo"
                      className="combo-image"
                    />
                  </div>
                  <p className="availability-info">
                    <strong>Apply on:</strong>{" "}
                    {props.comboDetailsData?.kiosk_app_enabled && 
                     props.comboDetailsData?.consumer_app_enabled
                      ? "Kiosk and Consumer App"
                      : props.comboDetailsData?.kiosk_app_enabled
                      ? "Kiosk"
                      : props.comboDetailsData?.consumer_app_enabled
                      ? "Consumer App"
                      : "Not available"}
                  </p>
                </div>

                <div className="combo-details-right">
                  <div className="price-date-container">
                    <div className="price-box">
                      <p><strong>Actual Price:</strong> ₹{props.comboDetailsData?.actual_price}</p>
                      <p><strong>Selling Price:</strong> ₹{props.comboDetailsData?.total_price}</p>
                    </div>
                    <div className="date-box">
                      <p>
                        <strong>Active Date:</strong>{" "}
                        {moment.utc(props.comboDetailsData?.activates_at)
                          .tz("Asia/Kolkata")
                          .format("YYYY-MM-DD")}
                      </p>
                      <p className="expire-date">
                        <strong>Expire Date:</strong>{" "}
                        {moment.utc(props.comboDetailsData?.expires_at)
                          .tz("Asia/Kolkata")
                          .format("YYYY-MM-DD")}
                      </p>
                    </div>
                  </div>

                  <div className="mvid-table-container">
                  
                    <div className="mvid-table-wrapper">
                      <table className="mvid-table">
                        <thead>
                          <tr>
                            <th>MVID</th>
                            <th>Quantity</th>
                            <th>Price</th>
                          </tr>
                        </thead>
                        <tbody>
                          {props.comboDetailsData?.mv_config?.map((item) => (
                            <tr key={item.mv_id}>
                              <td>{item.mv_id}</td>
                              <td>{item.quantity}</td>
                              <td>{item.price}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Combo Mapping Section */}
          <div className="combo-mapping-section">
            <div className="section-header">
              <div className="section-title">
                <img src={combodetailsIcon} alt="Combo" />
                <h2>Combo Mapping</h2>
              </div>
              <div className="mapping-actions">
                {props.comboDetailsData?.combo_cohorts?.length > 0 ? (
                  <>
                    <button 
                      className="action-button remove-button"
                      onClick={props.handleRemoveClick}
                    >
                      Remove
                    </button>
                    <button 
                      className="action-button add-button"
                      onClick={() => handleAddCohortCombo(comboId)}
                    >
                      Add
                    </button>
                  </>
                ) : (
                  <button 
                    className="action-button add-button"
                    onClick={() => handleAddCohortCombo(comboId)}
                  >
                    Add
                  </button>
                )}
              </div>
            </div>

            {props.comboDetailsData?.combo_cohorts?.length > 0 ? (
              <div className="mapping-content">
                <div className="search-container">
                  <img src={search} alt="Search" className="search-icon" />
                  <input
                    type="search"
                    value={machineSearchQuery}
                    onChange={handleSearchChange}
                    placeholder="Search by cohort ID"
                    className="search-input"
                  />
                </div>

                <div className="cohort-table-container">
                  <Table responsive className="cohort-table">
                    <thead>
                      <tr>
                        <th style={{ width: "60px" }}></th>
                        <th>Cohort ID</th>
                        <th>V.M ID</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredCohorts?.length > 0 ? (
                        filteredCohorts.map((item) => (
                          <tr key={item.cohort_id}>
                            <td>
                              {props.showTableForRemoval && (
                                <button 
                                  className="remove-icon-button"
                                  onClick={() => props.handleConfirmRemove(item.cohort_id)}
                                >
                                  <img src={remove} alt="Remove" />
                                </button>
                              )}
                            </td>
                            <td>{item.cohort_id}</td>
                            <td>
                              {item.vm_ids.slice(0, 20).join(", ")}
                              {item.vm_ids.length > 20 && (
                                <button 
                                  className="see-more-button"
                                  onClick={() => handleSeeMore(item.vm_ids)}
                                >
                                  ... See More
                                </button>
                              )}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="3" className="no-results">
                            No cohorts found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </div>

                {props.showTableForRemoval && (
                  <button 
                    className="cancel-button"
                    onClick={props.handleCancelRemove}
                  >
                    Cancel
                  </button>
                )}
              </div>
            ) : (
              <div className="no-mapping-results">
                <div className="no-results-image">
                  <img src={emotions7} alt="No combos found" />
                </div>
                <p>No combos found</p>
              </div>
            )}
          </div>
        </div>
      )}

   

<Modal
  show={props.showConfirmModal}
  onHide={() => props.setShowConfirmModal(false)}
  centered
  className="confirmation-modal-wrapper"
>
  <Modal.Body className="confirmation-modal">
    <img src={awaitingIcon} alt="Confirmation" className="modal-icon" />
    <p className="modal-confirmation-text">Are you sure you want to remove it?</p>
    <div className="confirmation-buttons">
      <Button 
        variant="outline-primary" 
        onClick={() => props.setShowConfirmModal(false)}
        className="modal-cancel-btn"
      >
        Cancel
      </Button>
      <Button 
        variant="primary" 
        onClick={props.confirmRemove}
        className="modal-confirm-btn"
      >
        Confirm
      </Button>
    </div>
  </Modal.Body>
</Modal>



      
    </div>
  );
};